import { render } from "./benefits.vue?vue&type=template&id=311fce58&lang=pug"
import script from "./benefits.vue?vue&type=script&setup=true&lang=js"
export * from "./benefits.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__